import React from 'react';
import { Button, Grid, makeStyles, TextField } from '@material-ui/core';
import Filter from '../../assets/FilterIcon';
import FilterIconSelected from '../../assets/FilterIconSelected';

const SearchBox = ({ handleSearchChange, searchVal, filterCondition, placeholder, handleClick, menu }) => {
  const classes = useStyles();
  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="center" style={{ margin: '10px 10px' }}>
      <Grid item xs={9}>
        <TextField
          id="searchId"
          name="search"
          required
          autoComplete="off"
          autoSave="off"
          onChange={handleSearchChange}
          placeholder={placeholder}
          value={searchVal}
          InputProps={{
            disableUnderline: true,
            className: classes.searchText,
          }}
          rows={1}
        />
      </Grid>
      <Grid item xs={2}>
        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.featherPlus}>
          <Button
            variant="contained"
            focusRipple={false}
            disableElevation
            aria-controls="simple-menu"
            aria-haspopup="true"
            className={filterCondition ? classes.featherPlus : classes.featherPlusSelected}
            onClick={menu ? handleClick : () => {}}
          >
            {filterCondition ? (
              <Filter style={{ background: '#D3D3D3' }} />
            ) : (
              <FilterIconSelected style={{ background: 'white' }} />
            )}
          </Button>
          {menu}
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles(() => ({
  searchText: {
    height: '42px',
    background: '#FAFAFA',
    border: '2px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    marginRight: '9px',
  },
  featherPlus: {
    height: '42px',
    background: '#FAFAFA',
  },
  featherPlusSelected: {
    height: '42px',
    background: '#622FEE',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
export default SearchBox;
